(() => {
  const deKolom = () => document.querySelector('.vt-buy');
  if (!deKolom()) return;

  const varianten = (() => {
    const kaart = new Map();

    const eigen = document.querySelector('script[data-vt-prijzen]');
    if (eigen) {
      try {
        const data = JSON.parse(eigen.textContent);
        Object.entries(data).forEach(([id, p]) => {
          if (!p || typeof p.centen !== 'number') return;
          kaart.set(String(id), {
            id: Number(id),
            price: p.centen,
            compare_at_price: p.centenWas > p.centen ? p.centenWas : null,
            public_title: p.naam || '',
            options: p.naam ? [p.naam] : [],
            available: p.beschikbaar !== false,
            tekst: p.prijs || '',
            tekstWas: p.oud || '',
            tekstIncl: p.prijsIncl || '',
          });
        });
      } catch {
      }
    }

    if (kaart.size) return kaart;

    document.querySelectorAll('script[type="application/json"]').forEach((el) => {
      let data;
      try {
        data = JSON.parse(el.textContent);
      } catch {
        return;
      }
      const rij = Array.isArray(data) ? data : data?.variants;
      if (!Array.isArray(rij)) return;
      rij.forEach((v) => {
        if (v && typeof v.id === 'number' && typeof v.price === 'number') {
          kaart.set(String(v.id), v);
        }
      });
    });
    return kaart;
  })();

  const sleutel = (t) => String(t).trim().toLowerCase();

  function gekozenOpties() {
    const kiezer = deKolom()?.querySelector('.variant-picker');
    if (!kiezer) return null;

    const rijen = [...kiezer.querySelectorAll('.variant-option')];
    if (!rijen.length) return null;

    const waarden = rijen.map((rij) => {
      const aan = rij.querySelector('input:checked');
      if (aan) return sleutel(aan.value);
      const keuze = rij.querySelector('select');
      return keuze ? sleutel(keuze.value) : null;
    });
    return waarden.some((w) => w === null) ? null : waarden;
  }

  function huidigeVariant() {
    const opties = gekozenOpties();
    if (opties) {
      for (const v of varianten.values()) {
        if (!Array.isArray(v.options) || v.options.length !== opties.length) continue;
        if (v.options.every((o, i) => sleutel(o) === opties[i])) return v;
      }
      const samen = opties.join(' / ');
      for (const v of varianten.values()) {
        const naam = sleutel(v.public_title || '');
        if (!naam) continue;
        if (naam === samen) return v;
        const delen = naam.split('/').map(sleutel);
        if (delen.length === opties.length && delen.every((d, i) => d === opties[i])) return v;
      }
    }

    const veld = document.querySelector(
      '.vt-atc input[name="id"], .vt-buy input[name="id"], .vt-buy select[name="id"]'
    );
    if (veld && varianten.has(String(veld.value))) return varianten.get(String(veld.value));

    const uit = new URL(window.location.href).searchParams.get('variant');
    if (uit && varianten.has(uit)) return varianten.get(uit);

    return null;
  }

  const geld = (c) => window.vtGeld(c);

  function optieKop() {
    const kaart = deKolom()?.querySelector('.vt-kaart');
    const optie =
      kaart?.querySelector('fieldset.variant-option:has(input[data-option-name="Lengte"])') ||
      kaart?.querySelector('fieldset.variant-option');
    const kop = optie?.querySelector(':scope > legend');
    if (kop) kop.classList.add('vt-buy__optiekop');
    return kop || null;
  }

  function plaatsPil() {
    const pil = deKolom()?.querySelector('.vt-buy__pil');
    if (!pil) return;

    const doel = deKolom()?.querySelector('.vt-familie__koprij') || optieKop() || deKolom()?.querySelector('.vt-atc')?.parentElement;
    if (!doel || pil.parentElement === doel) {
      pil.classList.add('is-verplaatst');
      return;
    }

    if (doel.matches('.vt-familie__koprij, .vt-buy__optiekop')) doel.append(pil);
    else doel.insertBefore(pil, doel.firstChild);
    pil.classList.add('is-verplaatst');
  }

  function normaliseerOnderschrift() {
    deKolom()?.querySelectorAll('.vt-buy__vat').forEach((p) => {
      p.childNodes.forEach((n) => {
        if (n.nodeType !== 3) return;
        n.textContent = n.textContent
          .replace(/^\s*[·•]\s*/, '')
          .replace(/\s*[·•]\s*$/, '');
      });
      p.hidden = p.textContent.trim() === '';
    });
  }

  function zetBespaarpil(v) {
    const rij = deKolom()?.querySelector('.vt-buy__prijsrij');
    if (!rij) return;

    const gewenst =
      v && v.compare_at_price && v.compare_at_price > v.price
        ? (rij.dataset.bespaart || '[bedrag]').replace('[bedrag]', geld(v.compare_at_price - v.price))
        : null;

    const bestaand = [...deKolom()?.querySelectorAll('.vt-buy__save')];
    const goede = bestaand.find(
      (el) => el.parentElement === rij && el.textContent.trim() === gewenst
    );

    bestaand.forEach((el) => {
      if (el !== goede) el.remove();
    });
    normaliseerOnderschrift();

    if (!gewenst || goede) return;

    const pil = document.createElement('span');
    pil.className = 'vt-buy__save';
    pil.textContent = gewenst;
    rij.appendChild(pil);
  }

  function zetTekst(el, waarde) {
    if (!el) return;
    if (el.textContent.trim() !== waarde) el.textContent = waarde;
  }

  const buitenBlad = (el) => !el.closest('[data-lade]');

  function zetFormulierId(v) {
    if (!v) return;
    document
      .querySelectorAll('.vt-atc input[name="id"], .vt-buy form input[name="id"]')
      .forEach((veld) => {
        if (veld.type !== 'hidden') return;
        if (!buitenBlad(veld)) return;
        if (veld.value !== String(v.id)) veld.value = String(v.id);
      });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (!deKolom()?.contains(form) || !buitenBlad(form)) return;
    zetFormulierId(huidigeVariant());
  }, true);

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('.vt-buy .vt-atc button, .vt-buy button[type="submit"]');
    if (!knop || !buitenBlad(knop)) return;
    zetFormulierId(huidigeVariant());
  }, true);

  function zetPrijs(v) {
    if (!v) return;
    const vak = deKolom()?.querySelector('[data-vt-stuksprijs], .vt-buy__price b');
    const nu = v.tekst || geld(v.price);
    if (vak && v.tekstIncl) {
      const ex = vak.querySelector('.vtz-ex');
      const inc = vak.querySelector('.vtz-in');
      if (ex && inc) {
        if (ex.textContent !== nu) ex.textContent = nu;
        if (inc.textContent !== v.tekstIncl) inc.textContent = v.tekstIncl;
      }
    } else if (vak && vak.textContent !== nu) vak.textContent = nu;

    const oud = deKolom()?.querySelector('.vt-buy__price s');
    if (oud) {
      const actie = !!(v.compare_at_price && v.compare_at_price > v.price);
      const was = actie ? v.tekstWas || geld(v.compare_at_price) : '';
      if (oud.textContent !== was) oud.textContent = was;
      if (oud.hidden === actie) oud.hidden = !actie;
    }
  }

  function zetSeintje(v) {
    if (!v) return;
    const seintje = deKolom()?.querySelector('vt-seintje');
    const form = deKolom()?.querySelector('.vt-atc__form');
    if (!seintje || !form) return;
    const op = !v.available;
    if (seintje.hidden === op) seintje.hidden = !op;
    if (form.classList.contains('is-op') !== op) form.classList.toggle('is-op', op);
    if (seintje.dataset.variant !== String(v.id)) {
      seintje.dataset.variant = String(v.id);
      seintje.reset?.();
    }
  }

  function bijwerken(gekozen) {
    const v = gekozen || huidigeVariant();
    zetPrijs(v);
    plaatsPil();
    zetBespaarpil(v);
    zetFormulierId(v);
    zetSeintje(v);
  }

  bijwerken();

  document.addEventListener('change', (e) => {
    if (e.target.closest?.('.vt-buy .variant-picker')) bijwerken();
  }, true);
  document.addEventListener('shopify:product:select', (e) => {
    bijwerken(varianten.get(String(e.detail?.variantId)));
  }, true);

  if (window.MutationObserver) {
    new MutationObserver((rijen) => {
      const raakt = rijen.some((r) => {
        const doel = r.target;
        if (!doel || doel.nodeType !== 1) return false;
        return doel.closest?.('.vt-buy') || doel.querySelector?.('.vt-buy');
      });
      if (raakt) bijwerken();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
